import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IGetUserSettingsParams {
  username: string;
  domainName: string;
}

export interface IGetUserSettingsResult extends IResult {
  language: string;
  locale: string;
  timeZoneId: string;
  email: string;
  startPage: string;
}

export class GetUserSettingsRequest extends Request<IGetUserSettingsParams, IGetUserSettingsResult> {
  constructor(params: IGetUserSettingsParams) {
    super('getUserSettings', params);
  }
}
